import React, { FC, useContext } from 'react';

// Components
import { RankingTableHeader } from './RankingTableHeader/RankingTableHeader';
import { RankingTableBody } from './RankingTableBody/RankingTableBody';
import { ShowMoreButton } from './ShowMore/ShowMore';

// Utils
import { ConfigContext, TextBlockTailwind } from '@velinsi/smp-widgets-ui';

// Types
import { ITennisRankingNormalized } from '../../types';
import { ISubscriberInfo } from '../../../../../packages/types';

interface Props {
  ranking: ITennisRankingNormalized;
  limit: number;
  initialLimit: number;
  maxLimit: number;
  setLimit: React.Dispatch<React.SetStateAction<number>>;
  handleParticipantClick: (id: string | number, name: string) => void;
  handleSubscriptionClick?: (info: ISubscriberInfo, clickType: string) => void;
}

export const RankingTable: FC<Props> = ({
  ranking,
  limit,
  initialLimit,
  maxLimit,
  setLimit,
  handleParticipantClick,
  handleSubscriptionClick,
}) => {
  const { dataLabels } = useContext(ConfigContext);
  const hasMoreData = limit < maxLimit;
  const hasPlayers = ranking?.rows && ranking?.rows?.length > 0;

  if (!hasPlayers) {
    return <TextBlockTailwind text={dataLabels?.no_matches} />;
  }

  return (
    <>
      <div style={{ scrollbarWidth: 'none' }} className='w-full relative overflow-x-auto sm:overflow-x-visible mb-1 touch-pan-x text-4'>
        <table className='w-full min-w-full ranking-table'>
          <RankingTableHeader />
          <RankingTableBody rows={ranking?.rows ?? []} handleParticipantClick={handleParticipantClick} />
        </table>
      </div>
      <ShowMoreButton
        hasMoreData={hasMoreData}
        setLimit={setLimit}
        initialLimit={initialLimit}
        handleSubscriptionClick={handleSubscriptionClick}
      />
    </>
  );
};
